import { render } from "./collapse.vue?vue&type=template&id=7136a0ef&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=7136a0ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7136a0ef"

export default script